<template>
  <div>
    <a-card title="文档列表">
      <a-row style="margin-bottom: 12px;">
        <a-button type="primary" icon="file-add" style="float: right;" :loading="saving" @click="openForm({})">新增文档</a-button>
      </a-row>
      <a-table size="small" rowKey="id" :columns="columns" :dataSource="items" :loading="loading" :pagination="false">
        <div slot="model" slot-scope="value, item">
          {{ item.factory }} / {{ item.model }}
        </div>
        <div slot="action" slot-scope="value, item">
          <a-button-group>
            <a-button icon="edit" size="small" @click="openForm(item)">编辑</a-button>
            <a-popconfirm title="确定删除吗" @confirm="remove(item)">
              <a-button type="danger" icon="delete" size="small">删除</a-button>
            </a-popconfirm>
          </a-button-group>
        </div>
      </a-table>
    </a-card>

    <record-form v-model="visible" :form="targetRow" @save="save" />
  </div>
</template>

<script>
import { repairDocumentList, repairDocumentCreate, repairDocumentUpdate, repairDocumentDestroy } from '@/api/document'

export default {
  name: 'DocumentList',
  components: {
    RecordForm: () => import('./RecordForm.vue'),
  },
  data() {
    return {
      visible: false,
      loading: false,
      saving: false,
      targetRow: {},
      items: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          customRender: (value, item, index) => index + 1,
        },
        { title: '单号', dataIndex: 'doc_no', width: 150 },
        { title: '寄件人、寄件时间', dataIndex: 'sender1' },
        { title: '医院', dataIndex: 'hospital' },
        { title: '设备（厂家/型号）', dataIndex: 'model', scopedSlots: { customRender: 'model' } },
        { title: '机身号', dataIndex: 'body_no' },
        { title: '维修编号', dataIndex: 'repair_no' },
        { title: '快递单号', dataIndex: 'express_no1' },
        { title: '拍照', dataIndex: 'photo', customRender: (value, record) => (record.photo1 || record.photo2 ? '已拍' : '未拍') },
        // { title: '创建人', dataIndex: 'creator_name', width: 90 },
        { title: '创建时间', dataIndex: 'create_time', width: 150 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 160 },
      ],
    };
  },
  methods: {
    initialize() {
      this.list();
    },
    list() {
      this.loading = true;
      repairDocumentList({}).then(data => {
        this.items = data || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    openForm(item) {
      this.targetRow = { ...item };
      this.visible = true;
    },
    save(data) {
      this.saving = true;
      let request = this.targetRow.id
          ? repairDocumentUpdate({ ...this.targetRow, ...data })        // 编辑
          : repairDocumentCreate({ ...data, doc_no: this.makeDocNo() }); // 新增
      request.then(() => {
        this.$message.success(this.targetRow.id ? '保存成功' : '新增成功');
        this.visible = false;
        this.list();
      }).finally(() => {
        this.saving = false;
      });
    },
    remove(item) {
      repairDocumentDestroy({ id: item.id }).then(() => {
        this.$message.success('删除成功');
        this.list();
      });
    },
    formatNow(date) {
      const p = n => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${p(date.getMonth() + 1)}-${p(date.getDate())} ${p(date.getHours())}:${p(date.getMinutes())}`;
    },
    makeDocNo() {
      const d = new Date();
      const p = n => String(n).padStart(2, '0');
      const suffix = String(this.items.length + 1).padStart(2, '0');
      return `MNT-${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}-${suffix}`;
    },
  },
  mounted() {
    this.initialize();
  },
}
</script>

<style scoped>
</style>